module.exports = __webpack_public_path__ + "graphics/platform-bundle.ckh.bcd81c218a24045dca68ad2423beea4c.svg";